/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiBridgeAlert } from './ApiBridgeAlert';
import {
    ApiBridgeAlertFromJSON,
    ApiBridgeAlertFromJSONTyped,
    ApiBridgeAlertToJSON,
    ApiBridgeAlertToJSONTyped,
} from './ApiBridgeAlert';

/**
 * 
 * @export
 * @interface ApiBridgeAlerts
 */
export interface ApiBridgeAlerts {
    /**
     * 
     * @type {Array<ApiBridgeAlert>}
     * @memberof ApiBridgeAlerts
     */
    alerts: Array<ApiBridgeAlert>;
}

/**
 * Check if a given object implements the ApiBridgeAlerts interface.
 */
export function instanceOfApiBridgeAlerts(value: object): value is ApiBridgeAlerts {
    if (!('alerts' in value) || value['alerts'] === undefined) return false;
    return true;
}

export function ApiBridgeAlertsFromJSON(json: any): ApiBridgeAlerts {
    return ApiBridgeAlertsFromJSONTyped(json, false);
}

export function ApiBridgeAlertsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiBridgeAlerts {
    if (json == null) {
        return json;
    }
    return {
        
        'alerts': ((json['alerts'] as Array<any>).map(ApiBridgeAlertFromJSON)),
    };
}

export function ApiBridgeAlertsToJSON(json: any): ApiBridgeAlerts {
    return ApiBridgeAlertsToJSONTyped(json, false);
}

export function ApiBridgeAlertsToJSONTyped(value?: ApiBridgeAlerts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alerts': ((value['alerts'] as Array<any>).map(ApiBridgeAlertToJSON)),
    };
}

